// Brand mark — just the circular watermelon icon from the DIET WALA logo, no wrapper frame.
export function LogoMark({ size = 44, className = "" }) {
  return (
    <img
      src="/brand/dietwalaa-mark-transparent.png"
      alt="DietWalaa"
      width={size}
      height={size}
      className={`flex-shrink-0 ${className}`}
      style={{ width: size, height: size, objectFit: "contain", display: "block" }}
    />
  );
}

export function LogoLockup({ size = 44, className = "", showTagline = false }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      <div className="leading-none">
        <div className="font-display text-2xl md:text-[26px] tracking-tight">
          <span style={{ color: "var(--primary)" }}>Diet</span>
          <span style={{ color: "var(--red)" }}>Walaa</span>
        </div>
        {showTagline && (
          <div className="mt-1 text-[9px] font-bold uppercase tracking-[0.18em]" style={{ color: "var(--primary)" }}>
            Fuel your body · Fuel your life
          </div>
        )}
      </div>
    </div>
  );
}

export function LogoShield({ size = 160 }) {
  return <LogoMark size={size} />;
}
